import React from "react";
import logo from "../logo.svg";
import { Link } from 'react-router-dom';
import "./login.css";
import { Button, TextField } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import bgimage from "../login_bg2.svg";
import { setUserName , USER_ROLE } from "../utils/config";
import Cookies from 'js-cookie';

function Login() {
  const [enteredUsername, setEnteredUsername] = React.useState("");
  const [userRole, setUserRole] = React.useState("");
  const [enteredPassword, setEnteredPassword] = React.useState("");
  const navigate = useNavigate();

  const doLogin = (event:any) => {
    event.preventDefault();
   // alert(enteredUsername)
   if((enteredUsername == "user" || enteredUsername == "User") && enteredPassword=="etnauser@123") {

    
    var role = 'E';
    const expirationTime = new Date(new Date().getTime() +  50400000);
    const userData = {
      'username': enteredUsername,
      'userrole': role,
    };
    Cookies.set('auth', JSON.stringify(userData)/*, { expires: expirationTime } */);
    // setUserName( "Admin","SU");
    navigate("../home");
  }
  else  if((enteredUsername == "Admin" || enteredUsername == "admin") && enteredPassword=="Plaza12345!") {

      
      var role = 'S';
      const expirationTime = new Date(new Date().getTime() +  50400000);
      const userData = {
        'username': enteredUsername,
        'userrole': role,
      };
      Cookies.set('auth', JSON.stringify(userData)/*, { expires: expirationTime } */);
      // setUserName( "Admin","SU");
      navigate("../home");
    } else {
      toast.error("Wrong Credentials!!!", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
        hideProgressBar: true,
      });
      setTimeout(() => {
      }, 2100);
    }
    window.location.reload(); 
  }
  return (
    <div className="App">
      <div className="row m-0 bg_light_gray">
        <div className="col-md-12 pl-0 text-left">
          <img src={logo} className="p-3 width_10per"></img>
          
        </div>
        <div className="col-md-12">
        
            <div className="section">
            <img src={bgimage} className=" login_bg_left"  />
            <div className="vl mr-4"></div>
              <div className="login bg-white login_bg_right">
                <h3 className="border-bottom pb-3 text-left mb-4 mt-4">Login</h3>
                
                <div className="form-group text-left">
                 
                  <TextField  size="small" label="Username" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                    className="form-control" type="text" name='username' value={enteredUsername}

                    onChange={(e: any) => {
                      setEnteredUsername(e.target.value)
                    }}  >
                      
                      </TextField>
                  </div>

                <div className="form-group text-left">
                 
                    <TextField  size="small" label="Password" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                    className="form-control" type="password" name='password' value={enteredPassword}

                    onChange={(e: any) => {
                      setEnteredPassword(e.target.value)
                    }}  >
                      
                      </TextField>
                </div>


                {/*<Link to="/home/categories">*/}
                  <Button
                    className="btn btn-outline-dark btn-toolbar"
                    type="submit"
                    value="Login"
                   /* 
                    onClick={(e: any) => {
                      doLogin()
                    }} 
                  */
                   onClick={doLogin} 
                    
                  >
                    Login
                  </Button>
               {/* </Link> */}

          
              </div>
              <ToastContainer />
            </div>
          </div>
        </div>
      </div>
   );
}
export default Login;
